import {schedulingFlightEditorConfiguration} from 'components/flighteditor/scheduling/configuration';
import {createFlightEditorWrapper} from 'components/flighteditor/unified/configuration';
import {UnifiedFlightEditor} from 'components/flighteditor/unified/UnifiedFlightEditor';
import WithOrgData from 'components/WithOrgData';
import {RouteComponentProps, withRouter} from 'react-router-dom';

export const SchedulingFlightEditor = createFlightEditorWrapper<RouteComponentProps>(
    UnifiedFlightEditor,
    () => schedulingFlightEditorConfiguration
);

const FlightScheduleEdit = withRouter(WithOrgData(SchedulingFlightEditor));
FlightScheduleEdit.displayName = 'FlightScheduleEdit';

export default FlightScheduleEdit;
